/* OGC Sharing Tools page scripts - extracted from prototype/sharing-tools.html */

(function () {
  var els = document.querySelectorAll('.ogc-sharing-tools-page [data-reveal]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function(el){ el.classList.add('is-visible'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { io.observe(el); });
})();

/* Email signature: type the body, then reveal the signature */
  (function () {
    var section = document.getElementById('email');
    if (!section) return;
    var textEl = section.querySelector('.ew-type-text');
    var caret  = section.querySelector('.ew-caret');
    var full = "Hi Sarah,\n\nGreat to connect at the summit! As promised, here's the deck I mentioned. Would love to find time for a call this week…";
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var started = false;

    function run() {
      if (started) return;
      started = true;
      if (reduce) {
        textEl.textContent = full;
        return;
      }
      var i = 0;
      (function step() {
        textEl.textContent = full.slice(0, i);
        i++;
        if (i <= full.length) {
          setTimeout(step, 30 + Math.random() * 45);
        } else if (caret) {
          caret.style.display = 'none';
        }
      })();
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { run(); io.disconnect(); }
        });
      }, { threshold: 0.4 });
      io.observe(section);
    } else {
      run();
    }
  })();

  /* Splash screen: fade in the logo + tagline when it scrolls into view */
  (function () {
    var splash = document.querySelector('#splash .visual-splash');
    if (!splash) return;
    if (!('IntersectionObserver' in window)) { splash.classList.add('in-view'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { splash.classList.add('in-view'); io.disconnect(); }
      });
    }, { threshold: 0.4 });
    io.observe(splash);
  })();

  /* Mobile wallet: slide the card up when it scrolls into view */
  (function () {
    var wallet = document.querySelector('#wallet .visual-wallet');
    if (!wallet) return;
    if (!('IntersectionObserver' in window)) { wallet.classList.add('in-view'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { wallet.classList.add('in-view'); io.disconnect(); }
      });
    }, { threshold: 0.4 });
    io.observe(wallet);
  })();

if (window.lucide) { lucide.createIcons(); }